export class ContoDTO {
  conto: string;
  descrizione: string;
  area: string;
  capienza: number;
  residuo: number;
}
